import Vue from 'vue';
import axios from 'axios';
import {hasPermission} from "../../utils/permissions";

// Initial state
const state = {
  caseStudies: [],
  caseStudy: {},
  totalPages: 0,
  action: '', // Added to resolve undefined state property issue
};

// Getters
const getters = {
  caseStudy: (state) => state.caseStudy,
  caseStudies: (state) => state.caseStudies,
  totalPages: (state) => state.totalPages,
};

// Mutations
const mutations = {
  SET_CASE_STUDY(state, caseStudy) {
    state.caseStudy = caseStudy;
  },

  SET_CASE_STUDIES(state, caseStudies) {
    state.caseStudies = caseStudies;
  },

  SET_ACTION(state, action) {
    state.action = action;
  },

  SET_TOTAL_PAGES(state, totalPages) {
    state.totalPages = totalPages;
  },

  ADD_FAQ(state, FAQ) {
    state.FAQs.push(FAQ);
  },

  UPDATE_FAQ(state, FAQ) {
    const faqIndex = state.FAQs.findIndex((item) => item.id === FAQ.id);
    if (faqIndex !== -1) {
      Vue.set(state.FAQs, faqIndex, FAQ);
    }
  },

  DELETE_FAQ(state, FAQ) {
    const faqIndex = state.FAQs.findIndex((item) => item.id === FAQ.id);
    if (faqIndex > -1) {
      state.FAQs.splice(faqIndex, 1);
    }
  },
};

// Actions
const actions = {
  async getAllCaseStudy({ commit }, [page, search]) {
    if(hasPermission('case_study')){
      const permission = {
        headers: {
          'X-Permission': 'case_study',
        },
      };
      const productId = localStorage.getItem('product');
      try {
        const response = await axios.get(
            `/admin/case-study?page=${page}&product_id=${productId}&search=${search}`,
            permission
        );
        const res = response.data;
        const totalPages = Math.ceil(res.total / res.per_page);
        commit('SET_TOTAL_PAGES', totalPages);
        commit('SET_CASE_STUDIES', res.data);
      } catch (error) {
        console.error('Error fetching case studies:', error);
      }
    }
  },

  async create({}, post) {
    const formData = new FormData();
    formData.append('slug', post.new_slug);
    formData.append('title', post.title);
    formData.append('body', post.body);
    formData.append('caption', post.caption);
    formData.append('meta_title', post.meta_title || '');
    formData.append('meta_description', post.meta_description || '');
    formData.append('meta_keyword', post.meta_keyword || '');
    formData.append('show_in_admin', post.show_in_admin ? 1 : 0);
    formData.append('featured', post.featured ? 1 : 0);
    formData.append('send_email', post.send_email ? 1 : 0);
    formData.append('remove_image', post.remove_image ? 1 : 0);
    formData.append('short_description', post.short_description  || '');
    if(hasPermission('new_case_study')){
      const permission = {
        headers: {
          'X-Permission': 'new_case_study',
        },
      };

      try {
        const response = await axios.post(
            `/admin/case-study/create?product_id=${localStorage.getItem('product')}`,
            formData,
            permission
        );
        return response.data;
      } catch (error) {
        console.error('Error creating case study:', error);
      }
    }
  },

  async update({}, post) {
    const formData = new FormData();
    formData.append('_method', 'PUT');
    formData.append('id', post.id);
    formData.append('slug', post.new_slug);
    formData.append('title', post.title);
    formData.append('body', post.body);
    formData.append('meta_title', post.meta_title || '');
    formData.append('meta_description', post.meta_description || '');
    formData.append('meta_keyword', post.meta_keyword || '');
    formData.append('short_description', post.short_description || '');
    formData.append('show_in_admin', post.show_in_admin ? 1 : 0);
    formData.append('featured', post.featured ? 1 : 0);
    formData.append('send_email', post.send_email ? 1 : 0);
    formData.append('remove_image', post.remove_image ? 1 : 0);
    if (post.caption !== undefined) {
      formData.append('caption', post.caption);
    }
    if(hasPermission('new_case_study')){
      const permission = {
        headers: {
          'X-Permission': 'new_case_study',
        },
      };

      try {
        const response = await axios.post(
            `/admin/case-study/update/${post.slug}?product_id=${localStorage.getItem('product')}`,
            formData,
            permission
        );
        return response;
      } catch (error) {
        console.error('Error updating case study:', error);
      }
    }

  },

  async view({ commit }, slug) {
    if(hasPermission('case_study')){
      const permission = {
        headers: {
          'X-Permission': 'case_study',
        },
      };
      const productId = localStorage.getItem('product');
      try {
        const response = await axios.get(`/admin/case-study/${slug}/${productId}`, permission);
        console.log("data resp ->",  response.data.data.caption);

        commit('SET_CASE_STUDY', response.data.data);
      } catch (error) {
        console.error('Error fetching case study:', error);
      }
    }
  },

  async delete({}, FAQ) {
    const productId = localStorage.getItem('product');
    try {
      const response = await axios.post(`/admin/case-study/delete/${FAQ.slug}/${productId}`, {
        '_method': 'DELETE',
      });
      return response.data;
    } catch (error) {
      console.error('Error deleting case study:', error);
    }
  },

  async publishing({ commit }, payload) {
    const productId = localStorage.getItem('product');
    try {
      const response = await axios.post(
        `/admin/case-study/publish/${payload.FAQ.slug}/${payload.action}?product_id=${productId}`
      );
      switch (payload.action) {
        case 'publish':
          payload.FAQ.published = 1;
          payload.FAQ.published_at = 'Just now';
          break;
        case 'unpublish':
          payload.FAQ.published = 0;
          payload.FAQ.published_at = '';
          break;
      }
      commit('SET_CASE_STUDY', payload.FAQ);
      return response;
    } catch (error) {
      console.error('Error publishing case study:', error);
    }
  },
};

// Exporting the Vuex module
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
